import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NMFTAButtonComponent } from "@nmfta/nmfta-ui";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@Component({
  selector: 'nmfta-pdf-viewer-modal',
  imports: [
    NgxSkeletonLoaderModule,
    PdfViewerModule,
    TranslateModule,
    // NMFTAButtonComponent
  ],
  templateUrl: './pdf-viewer-modal.component.html',
  styleUrl: './pdf-viewer-modal.component.scss'
})
export class PdfViewerModalComponent implements OnInit {
  @Input() data!: any;

  protected pdfSrc: any;
  protected isLoading = true;
  ngOnInit(): void {
    if (!this.data.fileData) return;
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>): void => {
      this.pdfSrc = e.target?.result;
      this.isLoading = false;
    };

    reader.readAsArrayBuffer(this.data.fileData);
  }

  onPdfLoaded(): void {
    this.isLoading = false;
  }
}